/**
 * District Context
 * Provides district information throughout the application
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { getDistrictCode, isDevelopment } from '../utils/districtConfig';

const DistrictContext = createContext();

export function useDistrict() {
  const context = useContext(DistrictContext);
  if (!context) {
    throw new Error('useDistrict must be used within a DistrictProvider');
  }
  return context;
}

export function DistrictProvider({ children }) {
  const [districtCode, setDistrictCode] = useState(getDistrictCode());
  const [isDevMode, setIsDevMode] = useState(isDevelopment());

  useEffect(() => {
    // Update district code if URL changes (e.g., query parameter changes)
    const handleLocationChange = () => {
      const newDistrictCode = getDistrictCode();
      if (newDistrictCode !== districtCode) {
        console.log('[DistrictContext] District changed to:', newDistrictCode);
        setDistrictCode(newDistrictCode);
      }
    };

    // Listen for browser navigation events
    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, [districtCode]);

  const value = {
    districtCode,
    isDevMode,
    // Helper to get district display name (can be customized per district)
    getDistrictDisplayName: () => {
      const names = {
        garland: 'Garland ISD',
        dallas: 'Dallas ISD',
        plano: 'Plano ISD',
        // Add more districts as needed
      };
      return names[districtCode] || districtCode.charAt(0).toUpperCase() + districtCode.slice(1) + ' ISD';
    }
  };

  return (
    <DistrictContext.Provider value={value}>
      {children}
    </DistrictContext.Provider>
  );
}

export default DistrictContext;
